import { cn } from "web-design-system";

function Pill({ fill }: { fill: boolean }) {
  return (
    <div className="h-1.25 w-6 rounded-4xl bg-muted overflow-hidden">
      <div
        className={cn(
          "bg-primary h-full rounded-4xl transition-[width] duration-200 ease-in-out",
          fill ? "w-full" : "w-0"
        )}
      />
    </div>
  );
}

/** Step indicator for the multi-step nominee dialog. */
export function ProgressPills({
  className,
  total,
  current,
}: {
  className?: string;
  total: number;
  current: number;
}) {
  return (
    <div className={cn("flex gap-1 items-center", className)}>
      {[...new Array(total)].map((_, i) => (
        <Pill key={i} fill={current > i} />
      ))}
    </div>
  );
}
